import {
  type BlockCore,
  type BuilderGetters,
  type BuilderState,
  type ResourceCore,
} from '../../types'

export const originalBlockById =
  <TResource extends ResourceCore, TBlock extends BlockCore>(
    state: BuilderState<TResource, TBlock>,
    _getters: BuilderGetters<TResource, TBlock>
  ) =>
  (blockId: string): TBlock | undefined => {
    return state._builder_originalState.blocks.find(
      (block: { id: string }) => block.id === blockId
    )
  }
